export interface IState {
  name: string;
  abbr: string;
  center: { lat: number; lng: number };
}

const STATES: IState[] = [
  { name: 'Alabama', abbr: 'AL', center: { lat: 32.806671, lng: -86.79113 } },
  { name: 'Alaska', abbr: 'AK', center: { lat: 61.370716, lng: -152.404419 } },
  { name: 'Arizona', abbr: 'AZ', center: { lat: 33.729759, lng: -111.431221 } },
  { name: 'Arkansas', abbr: 'AR', center: { lat: 34.969704, lng: -92.373123 } },
  {
    name: 'California',
    abbr: 'CA',
    center: { lat: 36.116203, lng: -119.681564 },
  },
  {
    name: 'Colorado',
    abbr: 'CO',
    center: { lat: 39.550051, lng: -105.782067 },
  },
  {
    name: 'Connecticut',
    abbr: 'CT',
    center: { lat: 41.597782, lng: -72.755371 },
  },
  { name: 'Delaware', abbr: 'DE', center: { lat: 39.318523, lng: -75.507141 } },
  { name: 'Florida', abbr: 'FL', center: { lat: 27.766279, lng: -81.686783 } },
  { name: 'Georgia', abbr: 'GA', center: { lat: 32.673539, lng: -84.49727 } },
  { name: 'Hawaii', abbr: 'HI', center: { lat: 20.902977, lng: -156.357437 } },
  { name: 'Idaho', abbr: 'ID', center: { lat: 44.068202, lng: -114.742043 } },
  { name: 'Illinois', abbr: 'IL', center: { lat: 40.349457, lng: -88.986137 } },
  { name: 'Indiana', abbr: 'IN', center: { lat: 40.267194, lng: -86.134902 } },
  { name: 'Iowa', abbr: 'IA', center: { lat: 42.011539, lng: -93.210526 } },
  { name: 'Kansas', abbr: 'KS', center: { lat: 38.5266, lng: -96.726486 } },
  { name: 'Kentucky', abbr: 'KY', center: { lat: 37.66814, lng: -84.670067 } },
  {
    name: 'Louisiana',
    abbr: 'LA',
    center: { lat: 31.169546, lng: -91.867805 },
  },
  { name: 'Maine', abbr: 'ME', center: { lat: 45.367584, lng: -68.972168 } },
  { name: 'Maryland', abbr: 'MD', center: { lat: 39.045753, lng: -76.641273 } },
  {
    name: 'Massachusetts',
    abbr: 'MA',
    center: { lat: 42.407211, lng: -71.382439 },
  },
  { name: 'Michigan', abbr: 'MI', center: { lat: 44.3467, lng: -85.4102 } },
  { name: 'Minnesota', abbr: 'MN', center: { lat: 46.2807, lng: -94.3053 } },
  {
    name: 'Mississippi',
    abbr: 'MS',
    center: { lat: 32.741646, lng: -89.678696 },
  },
  { name: 'Missouri', abbr: 'MO', center: { lat: 38.5739, lng: -92.6032 } },
  { name: 'Montana', abbr: 'MT', center: { lat: 46.921925, lng: -110.454353 } },
  { name: 'Nebraska', abbr: 'NE', center: { lat: 41.12537, lng: -98.268082 } },
  { name: 'Nevada', abbr: 'NV', center: { lat: 38.313515, lng: -117.055374 } },
  {
    name: 'New Hampshire',
    abbr: 'NH',
    center: { lat: 43.452492, lng: -71.563896 },
  },
  {
    name: 'New Jersey',
    abbr: 'NJ',
    center: { lat: 40.190362, lng: -74.672041 },
  },
  {
    name: 'New Mexico',
    abbr: 'NM',
    center: { lat: 34.840515, lng: -106.248482 },
  },
  { name: 'New York', abbr: 'NY', center: { lat: 42.165726, lng: -74.948051 } },
  {
    name: 'North Carolina',
    abbr: 'NC',
    center: { lat: 35.6301, lng: -79.8064 },
  },
  {
    name: 'North Dakota',
    abbr: 'ND',
    center: { lat: 47.528912, lng: -99.784012 },
  },
  { name: 'Ohio', abbr: 'OH', center: { lat: 40.388783, lng: -82.764915 } },
  { name: 'Oklahoma', abbr: 'OK', center: { lat: 35.565342, lng: -96.928917 } },
  { name: 'Oregon', abbr: 'OR', center: { lat: 44.572021, lng: -122.070938 } },
  {
    name: 'Pennsylvania',
    abbr: 'PA',
    center: { lat: 40.590752, lng: -77.209755 },
  },
  {
    name: 'Rhode Island',
    abbr: 'RI',
    center: { lat: 41.680893, lng: -71.51178 },
  },
  {
    name: 'South Carolina',
    abbr: 'SC',
    center: { lat: 33.8569, lng: -80.945 },
  },
  {
    name: 'South Dakota',
    abbr: 'SD',
    center: { lat: 44.299782, lng: -99.438828 },
  },
  {
    name: 'Tennessee',
    abbr: 'TN',
    center: { lat: 35.747845, lng: -86.692345 },
  },
  { name: 'Texas', abbr: 'TX', center: { lat: 31.054487, lng: -97.563461 } },
  { name: 'Utah', abbr: 'UT', center: { lat: 39.32098, lng: -111.093735 } },
  { name: 'Vermont', abbr: 'VT', center: { lat: 44.045876, lng: -72.710686 } },
  { name: 'Virginia', abbr: 'VA', center: { lat: 37.7693, lng: -78.17 } },
  {
    name: 'Washington',
    abbr: 'WA',
    center: { lat: 47.400902, lng: -121.490494 },
  },
  {
    name: 'West Virginia',
    abbr: 'WV',
    center: { lat: 38.4912, lng: -80.9544 },
  },
  { name: 'Wisconsin', abbr: 'WI', center: { lat: 44.2685, lng: -89.6165 } },
  { name: 'Wyoming', abbr: 'WY', center: { lat: 42.755966, lng: -107.30249 } },
];

export default STATES;
